import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

// Using `as string` to let Supabase's built-in validation throw a descriptive
// error if the env vars are missing, rather than silently falling back to
// placeholder credentials (per AGENTS.md security guidelines).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
        'Faltan las variables de entorno de Supabase. Asegúrate de configurar .env.local'
    );
}

export const supabase = createClient<Database>(
    supabaseUrl ?? 'https://placeholder-url.supabase.co',
    supabaseAnonKey ?? 'placeholder-key',
    {
        auth: {
            storageKey: 'soclean-coordinacion-auth',
            persistSession: true,
        }
    }
);
